const actions = [
  "/",
  "/login",
  "/user/search"
]
export default actions;